import { gql } from 'graphql-request'

import { NotifiableType } from '../subscriptions/notifications.subscriptions'

export namespace NotificationsQueries {
  export const QUERY_KEY = 'getNotificationAlerts'

  export namespace GET {
    export type Response = { notificationAlerts: NotificationAlert[] | null }
  }
  export function getNotificationAlerts() {
    return gql`
      query getNotificationAlerts($userId: Int!, $viewed: Boolean) {
        notificationAlerts(filter: { limit: 200, userIds: [$userId], viewed: $viewed }) {
          id
          createdAt
          notifiableId
          notificationId
          notifiableType
          message
          parentTicketId
          viewedAt
          parent {
            parentType
            parentId
          }
        }
      }
    `
  }
}

export interface NotificationAlert {
  createdAt: string
  id: number
  message: string
  notifiableId: number
  notifiableType: NotifiableType
  notificationId: number
  parent?: {
    parentId: number
    parentType: string
  }
  parentTicketId: number | null
  viewedAt: string | null
}
